import { api } from "./configs/axiosConfigs"
import { defineCancelApiObject } from "./configs/axiosUtils"

export const EpMasterAPI = {

  index: async function (cancel = false) {
    const response = await api.request({
      url: "/ep-master",
      method: "GET",
      signal: cancel ? cancelApiObject[this.index.name].handleRequestCancellation().signal : undefined,
    })

    return response.data
  },
}



// defining the cancel API object for ProductAPI
const cancelApiObject = defineCancelApiObject(EpMasterAPI)